import { createFileRoute } from "@tanstack/react-router";

/** The claims list alone: its layout (`_list.tsx`) renders it. */
export const Route = createFileRoute("/_authed/_dashboard/claims/_list/")({});
